<!-- 表格 -->
<template>
  <div class="page">
    <div class="search_out">
      <div class="left_part">
        <div class="search">
          <el-input v-model="form.search" placeholder="输入搜索关键字"></el-input>
          <button @click="searchBtn"><img src="../../../assets/search.png" alt="" />搜索</button>
        </div>
        <div class="btnGroup">
          <button class="reset" @click="reset">重置</button>
          <template v-if="isShow">
            <button @click="importData">导入</button>
            <button @click="handleExport">导出</button>
            <button @click="addTalent">新增达人</button>
            <button @click="getData">更新数据</button>
          </template>
        </div>
      </div>
      <div class="rigth_part">
        <div v-if="isShow">
          <span class="text progress">
            {{ progress }}
          </span>
        </div>
        <div>
          <span class="text">
            月份选择：
          </span>
          <el-date-picker
            v-model="form.month"
            type="month"
            placeholder="选择月"
            :picker-options="monthOpt"
          >
        </el-date-picker>
        </div>
      </div>
    </div>
    <el-table ref="tableData" :data="tableData" style="margin-top:30px;">
      <el-table-column
        prop="no"
        label="序号"
        width="50"
        fixed='left'>
      </el-table-column>
      <el-table-column  v-for="(item,index) in tableColumns" :key="index" :prop="item.field" :label="item.label" :width="item.width||'100'" :fixed="item.fixed">
        <!-- <template slot-scope="scope" v-if="item.field=='fans_age_fb_pct'">
            {{scope.row.fans_age_fb_pct}}%
          </template> -->
      </el-table-column>
      <el-table-column
        v-if="isShow"
        prop="updata_status"
        label="更新状态"
        width="100"
        fixed='right'>
      </el-table-column>
      <!-- <el-table-column v-for="(item,index) in columns1" :key="index" :prop="item.field" :label="item.label" :width="item.width||'100'"></el-table-column> -->
      <el-table-column
        v-if="isShow"
        fixed="right"
        label="操作"
        width="100">
        <template slot-scope="scope">
          <el-button @click="update(scope.row)" type="text" size="medium"><i class="el-icon-refresh"></i></el-button>
          <el-button @click="onEdit(scope.row)" type="text" size="medium"><i class="el-icon-edit"></i></el-button>
          <el-button @click="deleteRow(scope.row)" type="text" size="medium"><i class="el-icon-delete"></i></el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pages">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="pagination.count"
        @current-change="pageChange"
        :page-size="pagination.limit"
        :current-page.sync="pagination.page"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="导入文件"
      :visible.sync="importDialog"
      width="500px"
      :before-close="importDialogClose"
    >
      <el-upload
        :limit="1"
        ref="upload"
        accept=".xls,.xlsx"
        action
        :auto-upload="false"
        :on-remove="removeFile"
        :on-change="chooseFile"
      >
        <span
          v-if="chosenFile"
          @click.stop="
            () => {
              $message.warning('请移除当前文件后重新选择！');
            }
          "
        >
          <el-button slot="trigger" size="small" type="primary"
            >选择文件</el-button
          >
        </span>
        <template v-else>
          <el-button slot="trigger" size="small" type="primary"
            >选择文件</el-button
          >
        </template>
        <el-button style="margin-left: 10px;" size="small" type="primary" @click.stop="downloadTemplate">模板下载</el-button>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="importDialog = false">取 消</el-button>
        <el-button size="small" type="primary" @click="confirmImportFile"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="新增达人"
      :visible.sync="addDialog"
      width="600px"
      :before-close="addDialogClose"
    >
    <el-button size="small" type="primary" @click="addItem">新增</el-button>
    <el-form
      ref="addform"
      class="customer-form"
      :model="addform"
      label-width="97px"
      :inline="true"
      style="margin-top: 20px;"
    >
      <div v-for="(item, index) in addform.Items" :key="index">
        <el-form-item label="" class="form-style">
          <el-input style="width:350px" :placeholder="plat=='dy'? '请输入星图ID' :plat=='ks'? '请输入UID':plat=='bili' ? '请输入花火ID':plat=='xhs' ? '请输入UID':''" v-model="item.keyword" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button  type="danger" size="mini" @click="deleteItem(item, index)">删除</el-button>
        </el-form-item>
      </div>
    </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="addDialog = false">取 消</el-button>
        <el-button size="small" type="primary" @click="addConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <vxe-modal v-model="edit.show" title="达人编辑" width="800" className="custom-modal" show-footer destroy-on-close >
        <template #default>
          <vxe-form
            :data="edit.form"
            :items="edit.formItems"
          >
          </vxe-form>
        </template>
        <template #footer>
            <vxe-button size="mini" @click="edit.show = false">取消</vxe-button>
            <vxe-button size="mini" status="primary" @click="onEditConfirm">确定</vxe-button>
        </template>
    </vxe-modal>
  </div>
</template>
<script>

import * as XLSX from 'xlsx/xlsx.mjs'
import * as iconv from "iconv-lite";

export default {
  props:{
    plat:'',
  },
  data() {
    return {
      progress:'',
      tableData:[],
      isShow:true,
      form:{
        search:'',
        month:this.dayjs(new Date()).format('YYYY-MM'),
      },
      addform:{
        Items:[
          {
           keyword:'',
          }
        ]
      },
      columns1:[
        {
          field:'nickname',
          label:'达人昵称',
          fixed:'left',
          width:'180'
        },
        {
          field:'uniqueId',
          label:'抖音号',
          fixed:'left',
          width:'180'
        },
        {
          field:'uid',
          label:'UID',
          width:'180'
        },
        {
          field:'account_id',
          label:'星图ID',
          width:'180'
        },
        {
          field:'fromregion',
          label:'达人所在省份城市',
          width:'150'
        },
        {
          field:'fans',
          label:'粉丝量（万）',
          width:'150'
        },
        {
          field:'content_first_tag',
          label:'内容一级标签',
          width:'150'
        },
        {
          field:'content_second_tag',
          label:'内容二级标签',
          width:'150'
        },
        {
          field:'expectedcpm',
          label:'预期CPM',
        },
        // {
        //   field:'twentyprice',
        //   label:'1-20s报价',
        // },
        {
          field:'sixtyprice',
          label:'植入视频报价',
        },
        {
          field:'sixtyoverprice',
          label:'定制视频报价',
        },
        {
          field:'fans_sex_male',
          label:'男性粉丝占比',
          width:'150'
        },
        {
          field:'fans_sex_female',
          label:'女性粉丝占比',
          width:'150'
        },
        {
          field:'fans_age_fb_label',
          label:'粉丝年龄分布',
          width:'150'
        },
        {
          field:'fans_age_fb_pct',
          label:'粉丝年龄占比',
          width:'150'
        },
        {
          field:'homelink',
          label:'主页链接',
          width:'200'
        },
        {
          field:'last_video_time',
          label:'最新视频发布时间',
          width:'200'
        },
        {
          field:'control_status',
          label:'是否流量异常',
          width:'150'
        },
      ],
      columns2:[
        {
          field:'nickname',
          label:'达人昵称',
          fixed:'left',
          width:'180'
        },
        {
          field:'uniqueId',
          label:'快手号',
          fixed:'left',
          width:'180'
        },
        {
          field:'uid',
          label:'UID',
          width:'180'
        },
        {
          field:'account_id',
          label:'磁力聚星ID',
          width:'180'
        },
        {
          field:'fans',
          label:'粉丝量（万）',
          width:'150'
        },
        {
          field:'content_tag',
          label:'内容标签',
        },
        // {
        //   field:'twentyprice',
        //   label:'1-20s报价',
        // },
        {
          field:'sixtyprice',
          label:'植入视频报价',
        },
        {
          field:'sixtyoverprice',
          label:'定制视频报价',
        },
        {
          field:'expectedplayback',
          label:'预期播放量',
        },
        {
          field:'expectedcpm',
          label:'预期CPM',
        },
        {
          field:'fans_sex_male',
          label:'男性粉丝占比',
          width:'150'
        },
        {
          field:'fans_sex_female',
          label:'女性粉丝占比',
          width:'150'
        },
        {
          field:'fans_age_fb_label',
          label:'粉丝年龄分布',
          width:'150'
        },
        {
          field:'fans_age_fb_pct',
          label:'粉丝年龄占比',
          width:'150'
        },
        {
          field:'homelink',
          label:'主页链接',
          width:'150'
        },
        {
          field:'last_video_time',
          label:'最新视频发布时间',
          width:'200'
        },

      ],
      columns3:[
        {
          field:'nickname',
          label:'达人昵称',
          fixed:'left',
          width:'180'
        },
        {
          field:'uid',
          label:'UID',
          fixed:'left',
          width:'180'
        },
        {
          field:'uniqueId',
          label:'花火ID',
          width:'180'
        },
        {
          field:'fans',
          label:'粉丝量（万）',
          width:'150'
        },
        {
          field:'content_tag',
          label:'内容标签',
        },
        {
          field:'worksinteraction',
          label:'作品互动率',
        },
        {
          field:'fans_sex_male',
          label:'男性粉丝占比',
          width:'150'
        },
        {
          field:'fans_sex_female',
          label:'女性粉丝占比',
          width:'150'
        },
        {
          field:'fans_age_fb_label',
          label:'粉丝年龄分布',
          width:'150'
        },
        {
          field:'fans_age_fb_pct',
          label:'粉丝年龄占比',
          width:'150'
        },
        {
          field:'customizedvideoprice',
          label:'定制视频报价',
          width:'150'
        },
        {
          field:'implantvideoprice',
          label:'植入视频报价',
          width:'150'
        },

        {
          field:'dynamicvideoprice',
          label:'动态直发报价',
          width:'150'
        },
        {
          field:'dynamicsharevideoprice',
          label:'动态转发报价',
          width:'150'
        },
        {
          field:'homelink',
          label:'主页链接',
        },
        {
          field:'last_video_time',
          label:'最新视频发布时间',
          width:'200'
        },
      ],
      columns4:[
        {
          field:'nickname',
          label:'达人昵称',
          fixed:'left',
          width:'180'
        },
        {
          field:'uniqueId',
          label:'小红书号',
          fixed:'left',
          width:'180'
        },
        {
          field:'uid',
          label:'UID',
          width:'180'
        },
        {
          field:'fans',
          label:'粉丝量（万）',
          width:'150'
        },
        {
          field:'content_tag',
          label:'内容标签',
        },
        {
          field:'fans_sex_male',
          label:'男性粉丝占比',
          width:'150'
        },
        {
          field:'fans_sex_female',
          label:'女性粉丝占比',
          width:'150'
        },
        {
          field:'fans_age_fb_label',
          label:'粉丝年龄分布',
          width:'150'
        },
        {
          field:'fans_age_fb_pct',
          label:'粉丝年龄占比',
          width:'150'
        },
        {
          field:'twentyprice',
          label:'视频报价',
          width:'150'
        },
        {
          field:'price_73',
          label:'图文报价',
          width:'150'
        },
        {
          field:'homelink',
          label:'主页链接',
          width:'200'
        },
        {
          field:'last_video_time',
          label:'最新笔记发布时间',
          width:'200'
        },
      ],
      pagination: {
        count: 0,
        limit:10,
        page: 1,
      },
      importDialog: false,
      importFileData: [],
      chosenFile: false,
      addDialog:false,
      monthOpt:{
        disabledDate:time=>{
          return (time.getTime() > new Date())
        }
      },

      edit: {
        form: {
          is_hot:'',
          is_must:'',
          is_real_person: '',
          discount: '',
          is_same_price: '',
          rank_score: '',
          notes: '',
          reason: '',
        },
        formItems: [
          { field: 'is_hot', title: '是否火爆', span: 10, resetValue: '否', itemRender: { name: '$select', options: [{ value: '是', label: '是' }, { value: '否', label: '否' }], props: { placeholder: '请选择' } } },
          { span: 2},
          { field: 'is_must', title: '是否必选', span: 10, resetValue: '否', itemRender: { name: '$select', options: [{ value: '是', label: '是' }, { value: '否', label: '否' }], props: { placeholder: '请选择' } } },
          { field: 'is_real_person', title: '真人出镜', span: 10, resetValue: '否', itemRender: { name: '$select', options: [{ value: '是', label: '是' }, { value: '否', label: '否' }], props: { placeholder: '请选择' } } },
          { span: 2},
          { field: 'discount', title: '折扣', span: 10, itemRender: { name: '$input', props: { placeholder: '如7折，输入7' } } },
          { field: 'is_same_price', title: '实际接单价格是否与普通报价一致', resetValue: '是', span: 10, itemRender: { name: '$select', options: [{ value: '是', label: '是' }, { value: '否', label: '否' }], props: { placeholder: '请选择' } } },
          { span: 2},
          { field: 'rank_score', title: '特殊推荐', span: 10, resetValue: 0,  itemRender: { name: '$input', props: { placeholder: '请输入' } } },
          { field: 'notes', title: '其他备注', span: 24, itemRender: { name: '$textarea', props: { placeholder: '请输入' } } },
          { field: 'reason', title: '推荐理由', span: 24, itemRender: { name: '$textarea', props: { placeholder: '请输入' } } },
        ],
        show: false
      }
    };
  },
  computed:{
    tableColumns(){
      let cols = this.plat == 'dy' ? this.columns1 :
                this.plat == 'ks' ? this.columns2 :
                this.plat == 'bili' ? this.columns3 :
                this.plat == 'xhs' ? this.columns4 : []

      const commonCols = [
        {
          field:'is_hot',
          label:'是否火爆',
          width:'80'
        },
        {
          field:'is_must',
          label:'是否必选',
          width:'80'
        },
        {
          field:'discount',
          label:'折扣',
          width:'80'
        },
        {
          field:'reason',
          label:'推荐理由',
          width:'150'
        },
        {
          field:'is_real_person',
          label:'是否真人出镜',
          width:'80'
        },
        {
          field:'is_same_price',
          label:'实际接单价格是否与普通报价一致',
          width:'150'
        },
        {
          field:'notes',
          label:'备注说明',
          width:'150'
        },
      ]
      return [...cols,...commonCols]
    }
  },
  watch:{
    plat(){
      this.reset()
      this.importDialogClose()
      // this.getTableList()
      if(this.$refs.tableData){
        this.$refs.tableData.bodyWrapper.scrollLeft = 0
      }
    },
    "form.month":{
      handler(val){
        this.getShow(val)
        this.getTableList()

      },
      deep:true
    },

  },
  created() {
    this.getTableList()
    this.getShow(this.form.month)
  },
  methods: {
    async importData(){
      this.importDialog = true
      await this.$nextTick()
      this.$refs.upload.clearFiles()
    },
    downloadTemplate(){
      let baseUrl = `${window.location.protocol}//erp.changwankeji.com:8188`
      open(`${baseUrl}/api.php?a=downloadExportTemp&m=gx|api&plat=${this.plat}&token=${localStorage.getItem('api_token')}&adminid=${localStorage.getItem('uid')}`)
    },
    getShow(time){
      if(this.dayjs(time).isBefore(this.dayjs().subtract(1,'month'))){
           this.isShow = false
         }else{
          this.isShow = true
         }
    },
    getTableList(){
      let month =this.form.month? this.dayjs(this.form.month).format('YYYY-MM-01'):''
      let params = {
        plat:this.plat,
        key:this.form?.search||'',
        time:month,
        limit:this.pagination.limit,
        page:this.pagination.page
      }
      this.$axios.get('/api.php?a=getGxTanlent&m=gx|api', {params}).then(res => {

         console.log('res',res);
         this.tableData = res?.list
         this.tableData?.forEach((x,i)=>{
          x.no = (this.pagination.page-1)*this.pagination.limit+(i+1)
         })
         console.log('this.tableData',this.tableData);
         this.pagination.count = res?.pagelist?.count
         this.progress = res?.progress
      }).finally(() => {
        // loading.close()
      })
    },
    searchBtn(){
      this.getTableList()
    },
    reset(){
      this.form.search = ''
      this.pagination.page = 1
      this.getTableList()
    },

    handleExport(){
      let month =this.form.month? this.dayjs(this.form.month).format('YYYY-MM-01'):''
      let baseUrl = 'https://erp.changwankeji.com:8188'
      open(`${baseUrl}/api.php?a=exportData&m=gx|api&plat=${this.plat}&time=${month}&token=${localStorage.getItem('api_token')}&adminid=${localStorage.getItem('uid')}`)


    },
    addTalent(){
      this.addform.Items = [{keyword:''}];
      this.addDialog = true
    },
    getData(){
      let params ={
        plat:this.plat
      }
      this.$axios
        .get("/api.php?a=getSyncData&m=gx|api", { params })
        .then((res) => {
          if(res){
            this.$message.success('获取成功')
          }

        })
    },
    update(row){
      let params ={
        plat:this.plat,
        state:2,
        id:row?.id||''
      }
      this.$axios
        .get("/api.php?a=editTalent&m=gx|api", { params })
        .then((res) => {
          console.log(res);
          if(res){
            this.$message.success('数据获取中,请稍后刷新页面查看。')
            this.getTableList()
          }

        })
    },
    deleteRow(row){
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params ={
        plat:this.plat,
        state:1,
        id:row?.id||''
      }
      this.$axios
        .get("/api.php?a=editTalent&m=gx|api", { params })
        .then((res) => {
          console.log(res);
          if(res){
            this.$message.success('删除成功')
            this.getTableList()
          }
        })
      })

    },
    pageChange(val) {
      console.log('val',val);
      this.pagination.page = val
      this.getTableList()
    },
    importDialogClose() {
      this.importDialog = false;
      this.chosenFile = false;
      this.importFileData = [];
    },
    removeFile() {
      this.chosenFile = false;
      this.importFileData = [];
    },
    chooseFile(file) {
      this.chosenFile = true;
      const reader = new FileReader();
      reader.onload = (e) => {
        let list = [];
        if (file.name.includes(".csv")) {
          let ab = iconv.decode(Buffer.from(e.target.result, "hex"), "gbk");
          ab = ab.replaceAll('"', "");
          let a = ab.split("\n");
          a.shift();
          a.forEach((x, i) => {
            let arr = x.split(",").map((x) => x.trim());
            // if(i === a.length - 1){
              let isEmpty = arr.every(y => y === '')
              if(!isEmpty){
                list.push(arr)
              }
            // }else{
            //   list.push(arr);
            // }
          });
          this.importFileData = list;
        } else {
          const ab = e.target.result;
          const wb = XLSX.read(new Uint8Array(ab), { type: "array" });
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          /* Convert array of arrays */
          const data = XLSX.utils.sheet_to_json(ws, { header: 1, defval: "" });
          data.shift(); // 删除表头
          /* Update state */
          data.forEach((x, i) => {
            // if(i === data.length - 1){
              let isEmpty = x.every(y => y === '')
              if(!isEmpty){
                list.push(x)
              }
            // }else{
            //   list.push(x);
            // }
          })
          this.importFileData = list;
        }
        console.log("importFileData", this.importFileData);
      };
      reader.readAsArrayBuffer(file.raw);
    },
    async confirmImportFile() {
      if (!this.importFileData.length) {
        this.$message.warning("请先上传文件！");
        return;
      }
      let month =this.form.month? this.dayjs(this.form.month).format('YYYY-MM-01'):''
      let filterArr = this.importFileData.map(x => {
        if(x?.[3] && typeof x[3] === 'string'){
          x[3] = x[3].replace(/折/g, '')
        }
        return x
      })
      let params = {
        plat:this.plat,
        time:month,
        data: JSON.stringify(filterArr),
      };
      console.log("params", params);
      this.$axios.post("/api.php?a=improtData&m=gx|api", params)
        .then((res) => {
          this.importDialog = false;
          this.pagination.page = 1;
          this.getTableList();
        });
    },
    addDialogClose(){
      this.addDialog = false;
      this.addform.Items = [{keyword:''}];
    },
    addConfirm(){
      let params = {
        plat:this.plat,
        id:this.addform?.Items?.map(x => x ?.keyword)||''
      }
      console.log('params :>> ', params);
      this.$axios.post("/api.php?a=addTalent&m=gx|api", params)
        .then((res) => {
          this.addDialog = false;
          this.$message.success(res.msg)
          this.getTableList();
        });
    },
    //新增方法
    addItem() {
        this.addform.Items.push({
          keyword: '',
        })
    },
    //删除方法
    deleteItem(item, index) {
      this.addform.Items.splice(index, 1)
    },
    onEdit(row){
      const form = {
        id: row.id
      }
      this.edit.formItems.forEach(({field,resetValue = ''})=>{
        form[field] = row[field] ?? resetValue ?? ''
      })
      this.edit.form = form
      this.edit.show = true
    },
    async onEditConfirm(){
      const params = {
        plat: this.plat,
        ...this.edit.form
      }
      const res = await this.$axios.post("/api.php?m=gx&a=edit", params)
      this.edit.show = false
      this.getTableList()
    }
  }
};
</script>

<style lang='less' scoped>

.page{
  width: 100%;
  min-width: 1050px;
  background-color: #fff;
  padding:30px;
  box-sizing: border-box;
  .search_out{
    width:calc(100% - 60px) ;
    display:inline-flex;
    justify-content: space-between;
    flex-flow: row wrap;
    .left_part{
      display: flex;
      margin-bottom: 10px;
    }
    button {
      width: 90px;
      height: 38px;
      border: none;
      background-color: #FF5C00;
      font-size: 14px;
      font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
        "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
      font-weight: bold;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
        img {
        margin-right: 4px;
        }
    }
    button:hover {
      cursor: pointer;
      background-color: #FF4E00;
    }
    .text{
      font-size: 14px;
      font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
        "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
      font-weight: bold;
      vertical-align: middle;
    }
    .progress{
      margin-right: 20px;
    }
  }
  .search{
  display: flex;
  box-sizing: border-box;
  overflow: hidden;
  width: 460px;
  height: 38px;
  background: #FFFFFF;
  border: 1px solid #ff6f28;
  border-radius: 2px;
  /deep/.el-input__inner {
    border: none;
    }
  }
  .btnGroup{
    display: flex;
    button {
      margin-left: 15px;
      border-radius: 2px;
    }
    .reset{
      background: #fff;
      color: #000;
      border: 1px solid #ccc;
    }
    .reset:hover {
      cursor: pointer;
      background-color: #fff;
    }
  }
  .rigth_part{
    display: flex;
    align-items: center;
  }
}

</style>
<style>
.el-date-picker .el-month-table td .cell {
    text-align: center;
}
</style>